import React, { Component } from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import Loader from "../../../../../utils/loader/loaders";
import ServiceData from "./working-hours.json";
// import ZenForm from "../../../../input/zqform";
import ZenTabs from '../../../../global_components/KenForm/tabs';
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
// import HistoryIcon from "../../../../../assets/icons/history-icon.svg";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import moment from "moment";
// import ZqHistory from "../../../../../gigaLayout/change-history";
import { Drawer } from "rsuite";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import zq_api from "../../../../../utils/api-service";
import { Alert } from 'rsuite';

class WorkingHours extends Component {
  constructor(props) {
    super(props);
    // this.zq_api = new zq_api();
    this.state = {
      env: JSON.parse(localStorage.getItem("env")),
      useremail: localStorage.getItem("email"),
      channel: localStorage.getItem("channel"),
      BranchId: localStorage.getItem("branchid"),
      authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
      orgId: "606ac70479dbb25447375fa8",
      orgName: localStorage.getItem("orgName"),
      userId: localStorage.getItem("userId"),
      ServiceTableData: [
        {
          "ID": 'WH001',
          "Title": 'Technology',
          'Description': 'Technology',
          'Created By': 'Admin-Abhilash',
          "Version": "v1",
          'Status': 'Active'
        },
        {
          "ID": 'WH002',
          "Title": 'Creative',
          'Description': 'Creative',
          'Created By': 'Admin-Abhilash',
          "Version": "v1",
          'Status': 'Active'
        }, {
          "ID": 'WH003',
          "Title": 'Marketing',
          'Description': 'Marketing',
          'Created By': 'Admin-Abhilash',
          "Version": "v1",
          'Status': 'Active'
        }, {
          "ID": 'WH004',
          "Title": 'Human Resources',
          'Description': 'Human Resources',
          'Created By': 'Admin',
          "Version": "v1",
          'Status': 'Active'
        }, {
          "ID": 'WH005',
          "Title": 'Administration',
          'Description': 'Administration',
          'Created By': 'Admin-Abhilash',
          "Version": "v1",
          'Status': 'Active'
        },
        {
          "ID": 'WH006',
          "Title": 'Sales',
          'Description': 'Sales',
          'Created By': 'Admin-Abhilash',
          "Version": "v1",
          'Status': 'Active'
        },
      ],
      tabview: true,
      preview: true,
      ServiceFormData: ServiceData,
      departmentName: "",
      noProg: "Fetching Details..",
      loader: false,
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 1,
      tabData: [],
      SelectParentData: {
        id: "",
        name: "",
      },
      SelectParentExpenseData: {
        id: "",
        name: "",
      },
      "GST Tax Rate": "",
      Transaction: "",
      "TDS/Witholding Tax-Section": "",
      TDSApplicable: "",
      "Discount Start Date": "",
      date1: "",
      date2: "",
      globalSearch: false,
      username: localStorage.getItem("username"),
      entityInstanceId: "",
      idosId: "",
      history: false,
      showHistory: false,
      historyData: [],
      submitCheck: false,
      workingId: '',
      containerNav: {
        isBack: false,
        name: "Working Days",
        isName: true,
        isSearch: false,
        isSort: false,
        isPrint: true,
        isDownload: false,
        isShare: false,
        isNew: true,
        newName: "New",
        isSubmit: false,
      },
      wh: false,
      WHData: [],
      apiCall: false,
      wdData: []
    };
  }
  componentDidMount() {
    this.getWorkingHoursData();
  }
  componentWillMount() {
    // this.setState({ ServiceFormData: ServiceData }, () => {
    if (this.props.location.data != undefined) {
      // this.setState({ globalSearch: true }, () => {
      this.onPreviewServices(this.props.location.data);
      // })
    }
    // })
  }

  formatDate = (ev) => {
    var ts = new Date(ev);
    let getDate = `${String(ts.getDate()).length == 1 ? `0${ts.getDate()}` : ts.getDate()}`;
    let getMonth = `${String(ts.getMonth() + 1).length == 1 ? `0${ts.getMonth() + 1}` : ts.getMonth() + 1}`;
    let getYear = `${ts.getFullYear()}`
    let today = `${getDate}/${getMonth}/${getYear}`
    return today
  }
  getWorkingHoursData = () => {
    this.setState({ loader: true });
    var headers = {
      'Authorization': this.state.authToken
    }
    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/workingday?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
      .then(res => {
        // console.log(res.data.data, "workinghoursdata")
        if (res.data.status == 'success') {
          let tabData = [];
          let data = res.data.data;
          if (data.length > 0) {
            data.map(item => {
              let createdBy = "-"
              if (item.createdPersonInfo.length > 0) {
                createdBy = (String(item.createdPersonInfo[0].salutation).length > 1 ? (item.createdPersonInfo[0].salutation + ".") : "") + item.createdPersonInfo[0].firstName + " " + (item.createdPersonInfo[0].lastName != null ? String(item.createdPersonInfo[0].lastName).replace("-", "") : "")
              }
              tabData.push({
                "ID": item.id,
                "JobType": item.jobType,
                "From Date": this.formatDate(item.from),
                "To Date": this.formatDate(item.to),
                'Description': item.description,
                'Created By': createdBy,
                'Status': item.status,
                'Item': JSON.stringify(item)
              })
            })
            // filteredData.length > 10 ? this.setState({ totalPages: res.data.totalPages }) : this.setState({ totalPages: 1 })
            this.setState({
              tabData: tabData,
              page: res.data.currentPage,
              limit: res.data.perPage,
              totalPages: res.data.totalPages,
              totalRecord: res.data.totalRecord,
              loader: false
            });
          } if (data.length == 0) {
            this.setState({ loader: false, tabData: [], noProg: 'No data' });
          }
        }
      }).catch(err => {
        this.setState({ loader: false, tabData: [], noProg: 'No Data' });
      })
  };

  onSubmit = (data, item) => {
    console.log('data', data)
    console.log('item', item)
  }
  handleTabChange = (tabName, formDatas) => {
    console.log(tabName)
    console.log(formDatas)
  }
  onPreviewServices = (item) => {

    // this.setState({ employeeId: item['ID'] })
    // let departmentFormData = this.state.tabData
    // let fullName = String(item['Department Head'])
    // let firstName = fullName.split()[0]
    // let lastName = fullName.split()[1]
    this.setState({
      workingId: item.ID,
    })
    // departmentFormData['General']['0']['defaultValue'] = item['ID']
    // departmentFormData['General']['1']['defaultValue'] = item['JobType'];
    // departmentFormData['General']['2']['defaultValue'] = item['Description']
    let departmentFormData = this.state.ServiceFormData
    let details = this.state.globalSearch ? item : JSON.parse(item.Item)
    let entityInstanceId = details["_id"];
    let objKeys = Object.keys(details)

    this.setState({ tabview: false, preview: true, wdData: JSON.parse(details.whDetails), wh: true, apiCall: true, entityInstanceId: entityInstanceId });
    objKeys.map(key => {
      Object.keys(departmentFormData).forEach(dataKey => {
        departmentFormData[dataKey].map(item => {
          let itemName = item.name != undefined ? item.name.toLowerCase().replace(/ /g, "") : ""
          let keyName = key.toLowerCase().replace(/ /g, "")
          if (keyName == itemName) {
            item['defaultValue'] = details[key]
            item['readOnly'] = false
            item['required'] = false
          }
          if (item.name == "id") {
            item["defaultValue"] = details['id'];
            item["readOnly"] = false;
            item["required"] = false;
          }
          else if (item.name == "jobType") {
            item["defaultValue"] = details['jobType'];
            item["readOnly"] = false;
            item["required"] = false;
          }
          else if (item.name == "Description") {
            item["defaultValue"] = details['Description'];
            item["readOnly"] = false;
            item["required"] = false;
          }
        })
      })

    })
    this.setState({ ServiceFormData: departmentFormData });
    // this.getChangeHistory(entityInstanceId);
  };
  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getWorkingHoursData();
    });
  };
  resetform1 = () => {
    // let ServiceFormData = this.state.ServiceFormData;
    // ServiceFormData.map((item) => {
    //   item["defaultValue"] = undefined;
    //   item["readOnly"] = false;
    //   item["error"] = false;
    //   item["required"] = item.requiredBoolean
    //   item["validation"] = false
    // });
    // this.setState(ServiceFormData);
  };

  resetform = () => {
    let ServiceFormData = this.state.ServiceFormData;
    Object.keys(ServiceFormData).forEach((tab) => {
      ServiceFormData[tab].forEach((task) => {
        delete task["defaultValue"];
        task["readOnly"] = false;
        task["error"] = false;
        task["required"] = task["requiredBoolean"];
        task["validation"] = false;
      });
    });
    this.setState({ ServiceFormData });
  };

  onAddServices = () => {

  };
  handleBack = () => {
    if (this.props.location.status != "active") {
      this.resetform();
      this.setState({ tabview: true, preview: false });
    } else {
      this.props.history.goBack();
    }
  };
  onInputChanges = (value, item, e, dataS) => {
    console.log("value", value)
    console.log("item", item)
    console.log("e", e)
    console.log("dataS", dataS)
    if (dataS != undefined) {
      if (dataS["name"] === "jobType" || dataS["name"] === "from" || dataS["name"] === "to") {
        dataS["defaultValue"] = value;

      }
    }
    else {
      item["defaultValue"] = value
    }

  }
  formBtnHandle = (item) => {
    return item.type === "clear" ? this.cleartabData() : this.canceltabData();
  };
  cleartabData = () => {
    let issueDetailData = [];
    let formData = this.state.ServiceFormData;
    this.setState({ ServiceFormData: [] }, () => {
      formData.map((item) => {
        item["defaultValue"] = undefined;
        item["readOnly"] = false;
        if (item.required) {
          item["validation"] = false;
        }
      });
      issueDetailData = formData;
      console.log(issueDetailData, "issueDetailData");
      this.setState({
        ServiceFormData: issueDetailData,
      });
    });
  };
  canceltabData = () => {
    this.resetform();
    this.setState({ tabview: true });
  };
  getChangeHistory = (entityInstanceId) => {
    Axios.get(
      `${this.state.env["zqBaseUri"]}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=services&entityInstanceId=${entityInstanceId}`
    )
      .then((response) => {
        let api_data = response.data;
        let historyData = [];
        api_data.sort((data1, data2) => {
          return Number(data2.created_at) - Number(data1.created_at);
        });
        api_data.map((item) => {
          let date = new Date(
            new Intl.DateTimeFormat("en-US", {
              month: "2-digit",
              day: "numeric",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }).format(item["created_at"])
          );
          let descriptionData = item.description["0"]
            .split(",")
            .map((desc, i) => {
              return (
                <p key={i}>
                  <div style={{ display: "flex" }}>
                    <span className="span-hist" style={{ width: "5%" }}>
                      -
                    </span>
                    {desc}
                  </div>
                </p>
              );
            });
          console.log(descriptionData);
          historyData.push({
            description: descriptionData,
            time: moment(date).format("hh:mm"),
            created_at: item["created_at"]
              ? moment(date).format("DD/MM/YYYY (hh:mm A)")
              : "-",
            version: item.version,
            btn: false,
          });
        });
        this.setState({ historyData: historyData });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  showHistory = () => {
    this.setState({ history: true, showHistory: true });
  };
  onCloseForm = () => {
    this.setState({ showHistory: false });
  };
  onAddWorkingHours = () => {
    this.setState({ apiCall: false }, () => {
      this.resetform();

      let ServiceFormData = this.state.ServiceFormData;
      this.setState({ loader: true }, () => {
        var headers = {
          'Authorization': this.state.authToken
        }
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/payroll/generateNextId?type=WH&collection=workingdays`, { headers: headers })
          .then(res => {
            console.log(res.data.data)
            let workingId = res.data.data;
            Object.keys(ServiceFormData).map(k => {
              ServiceFormData[k].map((item) => {
                if (item.name == 'id') {
                  item["defaultValue"] = res.data.data;
                  item["readOnly"] = true;
                  item["error"] = false;
                  item["required"] = item.requiredBoolean
                  item["validation"] = false
                }
              });
            })

            this.setState({ ServiceFormData: ServiceFormData }, () => {
              this.setState({ tabview: false, preview: false, loader: false, workingId, wh: false })
            });

          }).catch(err => {
            this.setState({
              loader: false
            });
          })
      });


    })

  }
  onFormSubmit = (data, item, a, b) => {
    console.log(data, item, a, b)

    let userData = this.state.ServiceFormData;
    let apiNewCall = true;
    userData.map(item => {
      if (item.requiredBoolean) {
        if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
          item["error"] = true;
          item["validation"] = true
          item['errorMsg'] = `Invalid ${item.label}`
          apiNewCall = false
        } else {
          item["error"] = false;
          item["validation"] = false;
        }
      }
    })
    console.log(this.state.WHData)
    this.setState({ ServiceFormData: userData }, () => {
      if (apiNewCall) {
        this.setState({ loader: true }, () => {
          let payload = {
            "createdBy": this.state.userId,
            "updatedBy": this.state.userId,
          }
          Object.keys(data).map(k => {
            if (k == "General") {
              data[k].map(item => {
                payload[item.name] = item.defaultValue
              })
            }
          })
          payload['WHData'] = JSON.stringify(this.state.WHData)
          var headers = {
            'Authorization': this.state.authToken
          }
          if (!this.state.apiCall) {
            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/workingday`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getWorkingHoursData();
                      this.resetform();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                        this.resetform();
                      })
                    }, 2000)
                  })
                });
              })
          } else {
            Axios.put(`https://api.zenqore.com/payroll/uat/hkbk/masters/workingday?id=${this.state.entityInstanceId}`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getWorkingHoursData();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
        })
      }
    })
  }
  WorkingHrstabData = (wh) => {
    this.setState({ WHData: wh })
  }
  render() {
    return (
      <React.Fragment>
        {/* {this.state.loader ? <Loader /> : null} */}
        <div className="setup-page-wrapper department-tab">
          {this.state.tabview ? (
            <React.Fragment>
              {this.state.containerNav == undefined ? null : (
                <React.Fragment>
                  <KenContainerNavbar
                    containerNav={this.state.containerNav}
                    onAddNew={this.onAddWorkingHours}
                  />
                  <div className="print-time">{this.state.printTime}</div>
                </React.Fragment>

              )}
              <div className="trial-balance-header-title">
                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                  marginRight: '5px',
                  cursor: 'pointer',
                  marginTop: '0px'
                }} />
                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Working Days</p>
              </div>
              <div
                className="table-wrapper"
                style={{ marginTop: "10px" }}
              >
                {this.state.tabData.length == 0 ||
                  this.state.loader ? (
                  <p className="noprog-txt">{this.state.noProg}</p>
                ) : (
                  <React.Fragment>
                    <div className="remove-last-child-table">
                      <KenTable
                        data={this.state.tabData}
                        rowClick={(item) => {
                          this.onPreviewServices(item);
                        }}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="setup-pagination">
                  {this.state.tabData.length !== 0 && (
                    <KenPaginationUI
                      total={this.state.totalRecord}
                      onPaginationApi={this.onPaginationChange}
                      totalPages={this.state.totalPages}
                      limit={this.state.limit}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="tab-form-wrapper">
                <div className="goods-btns services-btns">
                  <div className="preview-header-wrap">
                    <div className="trial-balance-header-title">
                      <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.handleBack() }} style={{
                        marginRight: '5px',
                        cursor: 'pointer',
                        marginTop: '0px'
                      }} />
                      {this.state.preview ?
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Working Days | {this.state.workingId}</p> :
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Working Days  {`| ${this.state.workingId}`}</p>}
                    </div>
                    {/* {this.state.preview ? (
                        <React.Fragment>
                          <div
                            className="active-status-wrapper"
                            style={{ marginLeft: "10px" }}
                          >
                            <p className="active-status-content">Active</p>
                          </div>
                        </React.Fragment>
                      ) : null} */}
                  </div>
                  {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
                </div>
                <div className="tab-form-wrapper tab-table form-heading-tab">

                  {/* <div className="goods-wrapper service-wrapper form-heading-tab"> */}

                  {/* <ZenForm
                      formData={this.state.ServiceFormData}
                      className="goods-wrap"
                      onInputChanges={this.onInputChanges}
                      onFormBtnEvent={(item) => {
                        this.formBtnHandle(item);
                      }}
                      clear={true}
                      onSubmit={(e) => this.onSubmit(e.target.elements)}
                    /> */}
                  <ZenTabs tabData={this.state.ServiceFormData} className="preview-wrap" form={this.state.ServiceFormData} onFormBtnEvent={(item) => { this.formBtnHandle(item); }} onInputChanges={this.onInputChanges} onTabFormSubmit={this.onFormSubmit} handleTabChange={this.handleTabChange} clear={true} WorkingHrstabData={this.WorkingHrstabData} activeTab={this.state.activeTab} wh={this.state.wh} wdData={this.state.wdData} />

                </div>
                {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
              </div>
            </React.Fragment>
          )}
        </div>
        {/* {this.state.history ? (
          <Drawer show={this.state.showHistory} onHide={this.close}>
            <ZqHistory
              historyData={this.state.historyData}
              onCloseForm={this.onCloseForm}
            />
          </Drawer>
        ) : null} */}
      </React.Fragment>
    );
  }
}
export default withRouter(WorkingHours);
